import { render } from "./Points.vue?vue&type=template&id=6b235ded&scoped=true&ts=true"
import script from "./Points.vue?vue&type=script&lang=ts"
export * from "./Points.vue?vue&type=script&lang=ts"

import "./Points.vue?vue&type=style&index=0&id=6b235ded&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b235ded"]])

export default __exports__